import {
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES,
} from 'shared/constants';

const propsSchema = [
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'custom_background_color',
    label: 'Custom Background Color',
    type: types.OBJECT,
    options: false,
    children: [
      {
        key: 'use_custom_background',
        label: 'Use Custom Background Color',
        type: types.BOOLEAN
      },
      {
        key: 'color',
        label: 'Background Color',
        type: types.COLOR_PICKER
      }
    ]
  },
  {
    key: 'padding_for_menu_bar',
    label: 'Add Top Padding for Menu Bar',
    type: types.BOOLEAN,
  },
  {
    key: 'title',
    label: 'Page Title',
    type: types.TEXT,
  },
  {
    key: 'sections',
    label: 'Sections',
    type: types.ARRAY,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT
      },
      {
        key: 'open_in_new_tab',
        label: 'Open in a new tab',
        type: types.BOOLEAN
      },
    ]
  },
];

const defaultProps = {
  color_theme: 'DARK',
  custom_background_color: {
    use_custom_background: false,
    color: '#000000'
  },
  padding_for_menu_bar: true,
  title: '',
  sections: [
    {
      label: 'Home',
      url: '/'
    },
    {
      label: 'FF 91'
    }
  ],
};

export default {
  title: 'BreadCrumbs',
  id: 'BreadCrumbs',
  propsSchema,
  defaultProps
};
